import { useEffect, useState } from 'react';

import { useAddQuery } from './useAddQuery';
import { usePreviousValue } from './usePrevValue';
import { handleSnapDiff, upsertWorkspaceDraft, useAppDispatch, useAppSelector } from '../state';

export function useAutoSave() {
  const edit = useAppSelector((state) => state.edit);
  const [cur, pre] = usePreviousValue(edit);
  const [saveTime, setSaveTime] = useState<Date | null>(null);
  const dispatch = useAppDispatch();
  const setQuery = useAddQuery();

  useEffect(() => {
    let timer;
    clearTimeout(timer);
    timer = setTimeout(() => {
      const hasDiff = handleSnapDiff(pre, cur);
      if (hasDiff?.settingChange || hasDiff?.imgChange) {
        dispatch(
          upsertWorkspaceDraft({
            params: {
              npc_id: cur.npcId,
              setting_info: cur.settingInfo,
              img_info: cur.imgInfo,
              voice_info: cur.voiceInfo,
              plugin_list: cur.pluginList,
            },
          })
        ).then(() => {
          setSaveTime(new Date());
        });
      }
    }, 500);
    return () => {
      clearTimeout(timer);
    };
  }, [cur, dispatch, pre]);

  useEffect(() => {
    if (edit.npcId) {
      setQuery({ npc_id: edit.npcId });
    }
  }, [edit.npcId, setQuery]);

  return {
    saveTime,
  };
}
